import { ROOT_URL, ROOT_TITLE, VIEW_DEFINE_JSON} from '../src/common/viewDefine';

/**
 * Tealium Utag View
 * @param {*} paramScreen 
 * @param {*} product 
 */
export function postUtagView(paramScreen, product) {
	let url = ROOT_URL + paramScreen.virtualPage+'/';
	var _d = {};
	_d = JSON.parse(JSON.stringify(window.utag_data));
	_d['v_pageview'] = paramScreen.virtualPage;
	_d['dom_url'] = url;
	_d['page_name'] = paramScreen.title + ROOT_TITLE;
	// _d['page_url'] = url;
	// _d['pageurl_full_url'] = url;
	_d['page_url'] = location.href;
	_d['prod_id'] = product;
	if(paramScreen.extraFlg === true)
		postExtraUtagView(_d, paramScreen);
	window.utag.view(_d);
	// console.log('TAG VIEW:   '+paramScreen.virtualPage);
}

/**
 * Tealium Utag View Event
 * @param {*} cat カテゴリー
 * @param {*} ev イベント
 * @param {*} evLabel イベントラベル
 * @param {*} evValue イベント値
 */
export function postUtagEvent(cat, ev, evLabel, evValue) {
	window.utag_data.page_url = location.href;
	window.utag_data.v_pageview = location.href;
	window.utag.link({ ev_cat: cat, event: ev, ev_lbl: evLabel, ev_val: evValue });
}

/**
 * utag event 定義json
 */
export let UTAG_EVENT_JSON = [
	{
		risk_factor: 		'wl_risk_factor',
		plan: 				'wl-plan',
		contract_notice: 	'wl-important',
		select_payment: 	'wl-payment',
	},
	{
		ev_select:			'select',
		ev_click:			'Click',
	},
	{
		ev_value:			'1'
	}
];

/**
 * utag_data追加処理
 * @param {*} _d 
 * @param {*} paramScreen 
 */
function postExtraUtagView(_d, paramScreen) {
	_d['quote_amt'] = paramScreen.quote_amt;								//	見積金額
	_d['quote_expiry_date'] = paramScreen.quote_expiry_date;				//	
	_d['quote_prev_expiry_date'] = paramScreen.quote_prev_expiry_date;		//	
	_d['endorser'] = paramScreen.endorser;									//	
	_d['country'] = paramScreen.country;									//	
	_d['number_of_parson'] = paramScreen.number_of_parson;					//	
	_d['purpose'] = paramScreen.purpose;									//	
	_d['plancode'] = paramScreen.plancode;									//	
	if (paramScreen.name !== 'screen2') {
		_d['quote_id'] = paramScreen.quote_id;								//	
	}
	if (paramScreen.name === 'screen8') {
		_d['contract_amt'] = paramScreen.contract_amt;						//	
		_d['contract_paytype'] = paramScreen.contract_paytype;				//	
	}
}

(function () {
	// PCスマホ判定
	const device_id = (function () {
		var ua = navigator.userAgent;
		var device = 'PC';
		if (ua.indexOf('iPhone') > 0
				|| ua.indexOf('iPod')  > 0
				|| ((ua.indexOf('Android') > 0) && (ua.indexOf('Mobile') > 0))) {
			device = 'Mobile';
		} else {
			// Mobile以外の場合でTablet以外はPC判定
			if (ua.indexOf('iPad') > 0) {
				device = 'Tablet';
			}
		}
		return device;
	})();
	// // data-layer
	// window.utag_cfg_ovrd =  window.utag_cfg_ovrd || {};
	// window.utag_cfg_ovrd.noview = true;
	// window.utag_cfg_ovrd.noload = true;
	const screen = VIEW_DEFINE_JSON[0];
	const url = ROOT_URL+screen.virtualPage+'/';
	window.utag_data = {	
		device					: device_id || [],
		// v_pageview				: url || [],
		v_pageview				: location.href || [],
		// page_url				: url || [],
		page_url				: location.href || [],
		pageurl_full_url		: url || [],
		dom_url					: url || [],
		page_name				: screen.title+ROOT_TITLE || [],
		page_type				: 'Contract' || [],
		page_cat				: 'Product' || [],
		prod_id					: [],
		prod_name				: 'New'
	};
})();
